const diacritics = {
    a: 'ÀÁÂÃÄÅàáâãäåĀāąĄ',
    c: 'ÇçćĆčČ',
    d: 'đĐďĎ',
    e: 'ÈÉÊËèéêëěĚĒēęĘ',
    i: 'ÌÍÎÏìíîïĪī',
    l: 'łŁ',
    n: 'ÑñňŇńŃ',
    o: 'ÒÓÔÕÕÖØòóôõöøŌō',
    r: 'řŘ',
    s: 'ŠšśŚ',
    t: 'ťŤ',
    u: 'ÙÚÛÜùúûüůŮŪū',
    y: 'ŸÿýÝ',
    z: 'ŽžżŻźŹ',
};
/* ------------------------------------*\
        table of contents
    \*------------------------------------*/
function replaceDiacritics(text) {
    for (const toLetter in diacritics) {
        if (diacritics.hasOwnProperty(toLetter)) {
            for (var i = 0, ii = diacritics[toLetter].length, fromLetter, toCaseLetter; i < ii; i++) {
                fromLetter = diacritics[toLetter][i];
                if (text.indexOf(fromLetter) < 0) continue;
                toCaseLetter = fromLetter == fromLetter.toUpperCase() ? toLetter.toUpperCase() : toLetter;
                text = text.replace(new RegExp(fromLetter, 'g'), toCaseLetter);
            }
        }
    }
    return text;
}
function slugify(text) {
    return text
        .toString()
        .toLowerCase()
        .replace(/\s+/g, '-')
        .replace(/[^\w\-]+/g, '')
        .replace(/\-\-+/g, '-')
        .replace(/^-+/, '')
        .replace(/-+$/, '');
}

// build nav structure for table of contents
const articleSingle = document.querySelector('.single-page');
let articleContent;
let headings;

const header = document.querySelector('.rheader');
const headerResources = document.querySelector('.resources-header');
const singleMenu = document.querySelector('.single-nav nav');
let singleNav;
let singleNavAnchors = [];

if (articleSingle) {
    articleContent = articleSingle.querySelector('.content');
    headings = articleSingle.querySelectorAll('.content h2');

    /* headings = [].filter.call( headings, function(heading) {
            if (heading.getBoundingClientRect().width > 0) {
                return true;
            }
            return false;
        }); */

    if (singleMenu && headings.length > 1) {
        singleMenu.classList.add('visible');

        const inner = singleMenu.querySelector('.inner');

        // build
        singleNav = document.createElement('ul');
        singleNav.classList.add('nav');

        [].forEach.call(headings, (heading, num) => {
            const li = document.createElement('li');
            const anchor = document.createElement('a');
            const titleText = heading.innerText;

            const id = slugify(replaceDiacritics(titleText));

            if (document.getElementById('accessBox')) {
                anchor.setAttribute('href', '#accessBox');
            } else {
                anchor.setAttribute('href', `#${id}`);
            }
            heading.setAttribute('id', id);

            anchor.innerText = `${num + 1}. ${titleText}`;

            li.appendChild(anchor);
            singleNav.appendChild(li);
        });

        // init
        inner.appendChild(singleNav);
        singleNav.classList.add('visible');

        // set status for active link
        singleNavAnchors = singleNav.querySelectorAll('a');
        // singleNavAnchors[0].classList.add('active');

        const section = document.querySelectorAll('.content h2[id]');
        const sections = {};
        const i = 0;
        Array.prototype.forEach.call(section, (e) => {
            sections[e.id] = e.offsetTop;
        });

        /* window.onscroll = function() {
              var scrollPosition = document.documentElement.scrollTop + 155 || document.body.scrollTop + 155;

              for (i in sections) {
                if (sections[i] <= scrollPosition) {
                  document.querySelector('.active').setAttribute('class', ' ');
                  document.querySelector('aside nav a[href*=' + i + ']').setAttribute('class', 'active');
                }
              }
            }; */
    }

    /* ------------------------------------*\
            smooth scroll
        \*------------------------------------*/
    const referencesAnchors = document.querySelectorAll('a[id^="anchor"], a[href^="#anchor"]');

    [].forEach.call([].slice.call(singleNavAnchors).concat([].slice.call(referencesAnchors)), (anchor) => {
        anchor.addEventListener('click', (e) => {
            if (typeof anchor !== 'undefined' && anchor != null) {
                e.preventDefault();
                const target = anchor.hash;
                if (target === '#accessBox') {
                    window.accessDialog.show();
                    return;
                }
                if (document.querySelector(target).getBoundingClientRect().width > 0) {
                    window.scroll({
                        top: document.querySelector(target).getBoundingClientRect().top + document.documentElement.scrollTop - 70 - 75 - 10,
                        behavior: 'smooth',
                    });
                } else if (typeof window.accessDialog === 'object') {
                    window.accessDialog.show();
                }
            }
        });
    });
}
